<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="120"
      ref="FormComponent"
      @handleReset="handleReset"
      :fileHidden="false"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem :label="$t('In_position_since_ri')"
          ><!-- 本岗位开始日 -->
          <DatePicker
            type="date"
            v-model="formItem.changeDate"
            @on-change="formItem.changeDate = $event"
            style="width: 100%"
            clearable
          ></DatePicker>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem :label="$t('WHAT_Assessment_PPT')"
          ><!-- WHAT评分 -->
          <Select v-model="formItem.whatScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot2">
        <FormItem :label="$t('HOW_Assessment_PPT')"
          ><!-- HOW评分 -->
          <Select v-model="formItem.howScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot3">
        <FormItem :label="$t('Overall_Assessment_PPT')"
          ><!-- Overall评分 -->
          <Select v-model="formItem.wholeScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot4">
        <FormItem :label="$t('User_Potential')"
          ><!-- 潜能评分 -->
          <Select v-model="formItem.newPotentialScore" clearable>
            <Option
              v-for="item in NewPotentialScore"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot5">
        <FormItem :label="$t('PB_Calibration_Status')"
          ><!-- 校准状态 -->
          <Select v-model="formItem.checkStatus" clearable>
            <Option
              v-for="item in CheckStatus"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot6">
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot7">
        <FormItem :label="$t('Carlsberg_Band')"
          ><!-- 嘉士伯级别 -->
          <Select v-model="formItem.hcmBand" clearable>
            <Option v-for="item in Band" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot7">
        <FormItem :label="$t('keyPosition')"
          ><!-- 是否关键岗位 -->
          <Select v-model="formItem.key_position" clearable>
            <Option
              v-for="item in YesOrNoList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot7">
        <FormItem :label="$t('TalentPoolTag')"
          ><!-- 是否关键岗位 -->
          <Select v-model="formItem.talent_pool_list" clearable multiple>
            <Option
              v-for="item in talentPool"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6"  slot="slot11" >
        <FormItem :label="$t('movment')"
          ><!-- 绩效趋势 -->
          <Select v-model="formItem.movment" clearable>
            <Option
              v-for="item in movmentList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6"  slot="slot12">
        <FormItem :label="$t('TalentCategory')"
          ><!-- 人才类别 -->
          <Select v-model="formItem.talentCategoryName" clearable>
            <Option
              v-for="item in talentCategoryList"
              :value="item.ch_value"
              :key="item.ch_value"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <!-- 在职状态 -->
      <!-- <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot8">
      <FormItem :label="$t('PB_Employment_Status')">
        <Select v-model="formItem.beQuit" clearable style="width:100%">
          <Option
            v-for="item in BeQuit"
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </FormItem>
    </Col> -->
    </FormComponent>
    <AchAssessComponentCellByPeoBoard
      @saveScore="saveScore"
      @onShowMore="onShowMore"
      ref="AchAssessComponentCellByPeoBoardRef"
    />
    <Table
      border
      :loading="loading"
      :columns="colHidden"
      :data="data"
      style="margin: 20px 0"
      @on-select-cancel="TableSelectCancelRow"
      @on-select-all-cancel="cancelAll"
      @on-select-all="selsetAll"
      @on-select="peoOnSelectRow"
      ref="selection"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          :disabled="row.achApplyId == 'NotFindApplyId'"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="checkStatus"
        style="width: 100%"
      >
        <Select
          v-model="row.checkStatus"
          clearable
          @on-change="targetItemChange(row, index, 'checkStatus')"
          transfer
          :disabled="row.selsetDisabled"
        >
          <Option
            v-for="item in CheckStatus"
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="userName" style="width: 100%">
        <Button type="primary" size="small" @click="showCard(row, index)">{{
          row.userName
        }}</Button>
      </template>
      <template slot-scope="{ row }" slot="dirSupName" style="width: 100%">
        <Button type="primary" size="small" @click="showNewPage(row)">{{
          row.dirSupName
        }}</Button>
      </template>
       <template
        slot-scope="{ row, index }"
        slot="movment"
        style="width: 100%;"
      >
        <div style="display:flex;align-items: center;">
          <Button
            type="primary"
            icon="md-reorder"
            size="small"
            style="margin-right:10px"
            @click="onEditItem(row, index, 'overall')"
          >
            {{ $t("movment") }}
          </Button>
          <div>{{row[lang == "zh" ? "movment" : "movmentEName"]}}</div>
        </div>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="newPotentialScore"
        style="width: 100%"
      >
      <div style="display:flex;align-items: center;">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          style="margin-right:10px"
          @click="onEditItem(row, index, 'qn')"
        >
          {{ $t("User_Potential") }}
        </Button>
          <div>{{
            NewPotentialScore.filter(
                (item) => item.code == row.newPotentialScore
              ).map((res) => (lang == "zh" ? res.ch_value : res.en_value))[0]}}</div>
       </div>
      </template>
      <template slot-scope="{ row, index }" slot="action2">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="onEditItem(row, index, 'overall')"
        >
          {{ $t("movment") }}
        </Button>
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="onEditItem(row, index, 'qn')"
        >
          {{ $t("User_Potential") }}
        </Button>
      </template>
    </Table>
    <div
      style="
        margin: 10px 0 20px 0;
        display: flex;
        justify-content: space-between;
      "
    >
      <div style="display: flex">
        <Page
          :total="total"
          :current="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          @on-change="pageChange"
          :page-size-opts="[10, 50, 100, 150]"
          show-sizer
          @on-page-size-change="pageSizeChange"
        />
      </div>
      <div style="display: flex; align-items: center">
        <Button
          type="primary"
          style="margin-right: 10px"
          @click="showAllStatus = true"
          :disabled="beEnd == 1 || beEnd == 4"
          ><!-- 批量更新校准状态 -->{{
            $t("PB_Update_Calibration_Status")
          }}</Button
        >
        <Button
        type="primary"
         style="margin-right: 10px"
        @click="saveTable"
        :disabled="beEnd == 1 || beEnd == 4"
        ><!-- 保存 -->{{ $t("Save") }}</Button
      >
        <Button
          type="primary"
          @click="submitTable"
          :disabled="beEnd == 1 || beEnd == 4"
          ><!-- 提交 -->{{ $t("Submit") }}</Button
        >
        <Button
        type="primary"
        style="margin-left: 15px"
        @click="exportData"
        :disabled="loading"
        ><!-- 导出 -->{{ $t("PB_Export") }}</Button
      >
        <Button
          type="primary"
          @click="returnPage"
          v-if="showreturnbtn"
          style="margin-left: 15px"
          :disabled="loading"
          ><!-- 返回 -->{{ $t("Return") }}</Button
        >
      </div>
    </div>
    <Table
      :columns="columnsB"
      :data="exportTableData"
      ref="Table"
      id="Table"
      v-show="false"
    ></Table>
    <PotentialRange ref="PotentialRangeRef" @onSetScore="onSetScore" />
    <!-- 姓名点击 -->
    <Modal v-model="isShowDetal" :closable="false" fullscreen class="tab"
      ><!-- 人才卡片 -->
      <Tabs
        type="card"
        :value="showTabDetal"
        v-model="showTabDetal"
        :animated="true"
        name="talentCard"
      >
        <TabPane
          :label="$t('PB_Talent_Card')"
          name="a"
          :index="7"
          class="taletTab"
          tab="talentCard"
          v-if="isShowDetal"
          ><j2-talentCard
            ref="talentCard"
            v-if="isShowDetal"
            @back="isShowDetal = false"
          ></j2-talentCard
        ></TabPane>
        <TabPane
          :label="$t('PB_Performance__Sheet')"
          name="b"
          :index="8"
          class="taletTab"
          tab="talentCard"
          v-if="isShowDetal && isShowApplyForm"
          ><!-- 绩效表单 -->
          <j2-MyAchievements
            ref="MyAchievements"
            v-if="isShowDetal && isShowApplyForm"
          ></j2-MyAchievements>
        </TabPane>
        <TabPane
          :label="$t('团队概览')"
          name="c"
          :index="9"
          class="taletTab"
          tab="talentCard"
          ><!-- 团队概览 -->
          <TeamInfo ref="TeamInfoRef" />
        </TabPane>
        <div slot="extra">
          <Page
            :current="cardInit"
            :total="total"
            :page-size="1"
            simple
            prev-text="上一页"
            next-text="下一页"
            @on-change="cardChange"
          />
        </div>
      </Tabs>

      <div slot="footer">
        <Button type="text" @click="(isShowDetal = false), (showTabDetal = 'a')"
          ><!-- 返回 -->{{ $t("Return") }}</Button
        >
      </div>
    </Modal>
    <Modal
      v-model="showAllStatus"
      :title="$t('PB_Update_Calibration_Status')"
      width="400px"
      @on-ok="allStatusSave"
      ><!-- 批量更新校准状态 -->
      <Select clearable v-model="checkStatus" transfer>
        <Option
          v-for="item in CheckStatus"
          :value="item.code"
          :key="item.code"
          >{{ item.ch_value }}</Option
        >
      </Select>
    </Modal>
  </div>
</template>

<script>
import FormComponent from "../components/FormComponent.vue";
import AchAssessComponentCellByPeoBoard from "../components/AchAssessComponentCellByPeoBoard.vue";
import axios from "axios";
import PotentialRange from "../components/PotentialRange.vue";
import TeamInfo from "@/components/process/MyQuery/teamInfoComponents/tabPane1.vue";
export default {
  components: {
    FormComponent,
    AchAssessComponentCellByPeoBoard,
    PotentialRange,
    TeamInfo,
  },
  data() {
    return {
      formItem: {},
      searchItem: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 50,
      },
      Score: [],
      PotentialScore: [],
      YesOrNoList: [],
      PeoPleBoardStatus: [],
      ManagementLevel: [],
      Band: [],
      loading: false,
      selectList: [],
      data: [],
      exportTableData:[],
      saveStatus: false,
      id: "",
      allData: [],
      movment: [],
      NewPotentialScore: [],
      isShowDetal: false,
      isShowApplyForm: false,
      showTabDetal: "a",
      cardInit: 0,
      beEnd: "0",
      total: 0,
      editIndex: 0,
      CheckStatus: [],
      checkStatus: "",
      showAllStatus: false,
      showAllStatusDisabled: false,
      talentPool: [],
      movmentList:[
      {
          code:"3",
          ch_value:"高",
          en_value:"High"
        },
        {
          code:"2",
          ch_value:"中",
          en_value:"Low"
        },
        {
          code:"1",
          ch_value:"低",
          en_value:"Middle"
          
        },
      ],
      talentCategoryList:[
      {
          code:"1",
          ch_value:"聚焦绩效",
          en_value:"Performance Focus"
          
        },
        {
          code:"2",
          ch_value:"稳定贡献",
          en_value:"Core Talent"
        },
        {
          code:"3",
          ch_value:"后备力量",
          en_value:"Pipeline"
        },
        {
          code:"4",
          ch_value:"核心人才",
          en_value:"Strategic Few"
        },
      ],
      showreturnbtn: false,
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    mounted() {
      // this.getListData()
      this.$nextTick(() => {
        this.$refs.FormComponent.levelDisabledState = true;
        this.$refs.FormComponent.levelDisabled = true;
        this.$refs.FormComponent.pShow = true;
      });
      this.tableheight = window.innerHeight - 200;
      window.onresize = () => {
        return (() => {
          this.tableheight = window.innerHeight - 200;
        })();
      };
    },
    columnsB() {
      return [
        {
          title: this.$t("Emp_Ach_mess9") /* 审批状态 */,
          slot: "checkStatus",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          slot: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "position",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          slot: "dirSupName",
          align: "center",
          minWidth: 120,
          // sortable: true
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("movment") /* 绩效趋势 */,
          key: this.lang == "zh" ? "movment" : "movmentEName",
          align: "center",
          width: 95,
        },
        {
          title: this.$t("User_Potential") /* 潜能评分 */,
          key: "newPotentialScore",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              this.NewPotentialScore.filter(
                (item) => item.code == params.row.newPotentialScore
              ).map((res) => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          },
        },
        {
          title: this.$t("TalentCategory") /* 人才类别 */,
          key: this.lang == "zh" ? "talentCategoryName" : "talentCategoryEName",
          align: "center",
          width: 100,
        },
        {
          title: this.$t("Action") /* 操作 */,
          slot: "action2",
          align: "center",
          width: 210,
        },
      ];
    },
    columns() {
      return [
        {
          type: "selection",
          minWidth: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: this.$t("PB_Performance__Sheet") /* 绩效表单 */,
          key: "action",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "left",
        },
        {
          title: this.$t("Emp_Ach_mess9") /* 审批状态 */,
          slot: "checkStatus",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          slot: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "position",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          slot: "dirSupName",
          align: "center",
          minWidth: 120,
          // sortable: true
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("movment") /* 绩效趋势 */,
          key: this.lang == "zh" ? "movment" : "movmentEName",
          align: "center",
          slot:'movment',
          width: 165,
        },
        {
          title: this.$t("User_Potential") /* 潜能评分 */,
          slot: "newPotentialScore",
          align: "center",
          width: 185,
        },
        {
          title: this.$t("TalentCategory") /* 人才类别 */,
          key: this.lang == "zh" ? "talentCategoryName" : "talentCategoryEName",
          align: "center",
          width: 100,
        },
        // {
        //   title: this.$t("Action") /* 操作 */,
        //   slot: "action2",
        //   align: "center",
        //   width: 210,
        // },
      ];
    },
    colHidden: function () {
      //重点
      return this.columns.filter(function (e) {
        return !e.hidden;
      });
    },
  },

  created() {
    this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
  },

  methods: {
    returnPage() {
      this.$router.back();
    },
    exportData() {
      let obj = {
        id: this.id,
        pageNo: 1,
        pageSize: 10000,
        ...this.searchItem
      };
      this.loading = true;
      axios.post("/AchPeopleBoard/selectAchPeopleBoard", obj).then(res => {
        if (res) {
          this.exportTableData = res.achPeopleBoardList;
          this.exportTableData.forEach(el => {
            el.checkStatus = this.CheckStatus.filter(
              item => el.checkStatus == item.code
            ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            el.newPotentialScore = this.NewPotentialScore.filter(
              item => el.newPotentialScore == item.code
            ).map(res => (this.lang == "zh" ? res.ch_value : res.ch_value))[0];
          });
          this.$nextTick(() => {
            this.$exportExcel(
              "Table",
              "人才盘点" + this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm")
            );
            // this.$refs.Table.exportCsv({
            //     filename: '绩效评估',
            // });
          });
        }
        this.loading = false;
      });
    },
    submitTable() {
      this.saveStatus = false;
      let obj = {
        id: this.id,
        achPeopleBoardList: this.data,
      };
      axios.post("/AchPeopleBoard/checkPeoPleBoardSubmit", obj).then((res) => {
         if (res.result && res.result == 0) {
          this.$Modal.confirm({
            title: "请确认提交校准结果，并结束会议",
            onOk: () => {
              this.submitOk();
            },
          });
        } else {
          this.getData(JSON.stringify(this.searchItem));
        }
      });
    },
    onSetScore(e) {
      this.$set(this.data[this.editIndex], "newPotentialScore", e.score);
      this.saveScore();
    },
    allStatusSave() {
      if (this.data.length > 0) {
        let obj = {
          checkStatus: this.checkStatus,
          achPeopleBoardList: this.data,
        };
        axios.post("/AchPeopleBoard/saveAchCheckStatus", obj).then((res) => {
          if (res) {
            this.$Message.success("设置成功");
            this.data = [];
            this.getData(JSON.stringify(this.searchItem));
          }
        });
      } else {
        this.$Message.error(this.$t("Select_Employee"));
      }
    },
    cardChange(val) {
      this.cardInit = val;
      let serialnumber = "";
      let achApplyId = "";
      this.allData.forEach((res, index) => {
        if (res.init == val) {
          serialnumber = res.serialnumber;
          achApplyId = res.achApplyId;
          this.isShowApplyForm = achApplyId ? true : false;
          this.$refs.talentCard.getData(serialnumber);
          this.$refs.talentCard.buttonShow = false;
          this.$nextTick(() => {
            if (this.isShowApplyForm) {
              this.$refs.MyAchievements.id = achApplyId;
              this.$refs.MyAchievements.getPDInfo(achApplyId, serialnumber);
            } else {
              this.showTabDetal = "a";
            }
          });
          this.getTeamInfoData(serialnumber);
        } else {
        }
      });
    },
    showCard(item, index) {
      this.cardIndex = index;
      this.cardInit = Number(item.init);
      this.isShowDetal = true;
      this.isShowApplyForm = item.achApplyId ? true : false;
      this.showTabDetal = "a";
      this.$nextTick(() => {
        this.$refs.talentCard.getData(item.serialnumber, this.beEnd);
        this.$refs.talentCard.buttonShow = false;
        if (this.isShowApplyForm) {
          this.$refs.MyAchievements.id = item.achApplyId;
          this.$refs.MyAchievements.userinfoItem.year = item.year;
          this.$refs.MyAchievements.getPDInfo(
            item.achApplyId,
            item.serialnumber
          );
        }
        this.getTeamInfoData(item.serialnumber);
      });
    },
    getTeamInfoData(serialnumber) {
      if (this.$route.query.id) {
        this.$nextTick(() => {
          this.$refs.TeamInfoRef.btnShow = false;
        });
      }
      this.$nextTick(() => {
        this.$route.query.id
          ? (this.$refs.TeamInfoRef.id = this.$route.query.id)
          : "";
        this.$refs.TeamInfoRef.serialnumber = serialnumber;
        this.$refs.TeamInfoRef.empLoyeeDisabled = "1";
        this.$route.query.empLoyeeDisabled
          ? (this.$refs.TeamInfoRef.empLoyeeDisabled =
              this.$route.query.empLoyeeDisabled)
          : "";
        this.$refs.TeamInfoRef.getData();
      });
    },
    showNewPage(row) {
      const href =
        "/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27/?pageLink=name1&plan=true&id=" +
        this.id +
        "&serialnumber=" +
        row.dirSupSerialnumber +
        "&pagename=" +
        row.dirSupName +
        "&beEnd=" +
        this.$route.query.beEnd;
      window.open(href, "_blank");
    },
    checkBtn(row, index) {
      this.$router.push({
        path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
        query: {
          id: row.achApplyId,
          serialnumber: row.serialnumber,
          tabName: true,
        },
      });
    },
    onShowMore(e = {}) {
      this.formItem.whatScore = e.whatScope;
      this.formItem.howScore = e.howScope;
      this.formItem.wholeScore = e.wholeScope;
      this.saveScore();
    },
    saveScore() {
      this.getFormData(JSON.stringify(this.searchItem));
    },
    selectNineTableData() {
      this.loading = true;
      let obj = {
        id: this.id,
        ...this.searchItem,
        allData: this.allData,
        type: "",
      };
      this.axios.post("/achReport/selectNineTableData", obj).then((res) => {
        this.loading = false;
        this.$refs.AchAssessComponentCellByPeoBoardRef.data = res || [];
        this.$refs.AchAssessComponentCellByPeoBoardRef.allData = this.allData;
      });
    },
    onEditItem(row, index, type) {
      this.editIndex = index;
      row.isPBFlag = "1";
      this.$refs.PotentialRangeRef.onEditItem(row, type);
    },
    targetItemChange(row, index, key) {
      if (this.selectList.length > 0) {
        this.selectList.forEach((res, i) => {
          if (res.id == row.id) {
            this.$set(this.selectList[i], key, row[`${key}`]);
          }
        });
        key && this.$set(this.data[index], key, row[`${key}`]);
      } else {
        key && this.$set(this.data[index], key, row[`${key}`]);
      }
      this.$nextTick(() => {
        this.selectList.forEach((res) => {
          this.data.forEach((el, index) => {
            el._checked = false;
            if (el.id === res.id && el._disabled != true) {
              this.$refs.selection.objData[index]._isChecked = true;
            }
          });
        });
      });
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.functionList = res.functionList;
          this.Score = res.Score;
          this.PotentialScore = res.PotentialScore;
          this.YesOrNoList = res.YesOrNo;
          this.talentPool = res.TalentPool;
          this.PeoPleBoardStatus = res.PeoPleBoardStatus;
          this.ManagementLevel = res.ManagementLevel;
          this.Band = res.Band;
          this.movment = res.movment;
          this.NewPotentialScore = res.NewPotentialScore;
          this.CheckStatus = res.CheckStatus;
          this.$refs.AchAssessComponentCellByPeoBoardRef.NewPotentialScore =
            this.NewPotentialScore || [];
        }
      });
    },
    handleReset() {
      this.formItem = {};
      this.searchItem.year = "2025";
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      let obj = {
        id: this.id,
        ...this.pageInfo,
        ...this.searchItem,
      };
      let url = "";
      this.loading = true;
      url = "/AchPeopleBoard/selectAchPeopleBoard";
      this.data = [];
      axios.post(url, obj).then((res) => {
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
        if (res) {
          this.allData = res.allData;
          this.selectNineTableData();
          this.data = res.achPeopleBoardList || [];
          this.beEnd = res.beEnd;
          this.total = parseInt(res.pageInfo.total);
        }
      });
    },
    saveTable(){
      this.saveStatus = true;
      this.saveTableData();
    },
    saveTableData() {
      if (this.saveStatus) {
        this.loading = true;
        axios
          .post("/AchPeopleBoard/savePeopleBoardScore", this.data)
          .then((res) => {
            this.loading = false;
            if (res) {
              this.$Message.success(this.$t("Save_Successful"));
              this.getData(JSON.stringify(this.searchItem));
            }
          });
      } else {
        this.submitOk();
      }
    },
    submitOk() {
      let obj = {
        id: this.id,
        achPeopleBoardList: this.data,
      };
      this.loading = true;
      axios.post("/AchPeopleBoard/submitAchApproval", obj).then((res) => {
        this.loading = false;
        if (res) {
          this.$Message.success(res);
          this.getData(JSON.stringify(this.searchItem));
        }
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      //TODO
      this.saveStatus = true;
      this.saveTableData();
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    TableSelectCancelRow(selection, row) {
      this.selectList.forEach((el, index) => {
        if (el.id == row.id) {
          this.selectList.splice(index, 1);
        }
      });
    },
    peoOnSelectRow(selection, row) {
      if (!this.selectList.includes(row.id)) {
        this.selectList.push(row);
      }
    },
    selsetAll(selection) {
      this.data.forEach((el) => {
        if (!el._disabled) {
          this.selectList.push(el);
        }
      });
      let map = new Map();
      for (let item of this.selectList) {
        map.set(item.id, item);
      }
      this.selectList = [...map.values()];
    },
    cancelAll(selection) {
      this.data.forEach((row) => {
        this.selectList.forEach((el, index) => {
          if (el.id == row.id) {
            this.selectList.splice(index, 1);
          }
        });
      });
    },
  },

  checkBtn(row, index) {
    const href =
      "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
      row.achApplyId +
      "&serialnumber=" +
      row.serialnumber +
      "&achStage=" +
      row.achStage +
      "&year=" +
      row.year +
      "&userName=" +
      row.userName +
      "&returnFlag='1'";
    window.open(href, "_blank");
  },
};
</script>

<style lang="scss" scoped>
.chartBox {
  width: 100%;
}
.chartMain {
  display: flex;
  flex-wrap: wrap;
  .chartTable {
    width: 100%;
  }
  >>> .ivu-table th {
    background: #006b37;
    color: #fff;
  }
  >>> .ivu-table td.demo-table-info-column {
    background-color: #006b37;
    color: #fff;
  }
}

@media screen and (max-width: 900px) {
  .chartBox {
    width: 100%;
  }
  .chartMain {
    flex-wrap: wrap;
    .chartTable {
      width: 100%;
    }
  }
}

>>> .ivu-page-simple .ivu-page-simple-pager input {
  padding: 4px !important;
}
>>> .ivu-modal-fullscreen .ivu-modal-body {
  overflow-y: hidden;
  height: 100% !important;
  max-height: 100%;
}
.tab {
  zoom: 1.1;
  >>> .taletTab.ivu-tabs-tabpane {
    height: 100vh !important;
    overflow-y: auto !important;
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/PerformanceEvaluation2.vue